import 'jquery'
import { onDOMLoaded } from './util/misc.js'
import * as bootstrap from 'bootstrap'

onDOMLoaded(() => {
  let faqs = document.querySelectorAll('.schema-faq')
  let faqSections

  faqs.forEach((faq) => {
    faqSections = faq.querySelectorAll('.schema-faq-section')

    faqSections.forEach((faqSection) => {
      let question = faqSection.querySelector('.schema-faq-question')
      let answer = faqSection.querySelector('.schema-faq-answer')

      $(answer).addClass('collapse')

      question.addEventListener('click', () => {
        $(answer).slideToggle().addClass('show').prev().toggleClass('open')
      })
    })
  })

  $('body').on('added_to_cart', () => {
    bootstrap.Modal.getOrCreateInstance(document.getElementById('cartModal')).show()
  })

  let scrolldown = document.querySelector('.js-scrolldown')

  if(scrolldown) {
    scrolldown.addEventListener('click', (e) => {
      let nextBlock = e.target.parentNode.closest('.block').nextElementSibling
      nextBlock.scrollIntoView()
    })
  }

  scrolling()
})

const body = document.body,
      scrolled = 'scroll',
      ontop = 'scroll-ontop',
      scrollUp = 'scroll-up',
      scrollDown = 'scroll-down'

let lastScroll = 0

window.addEventListener('scroll', () => {
  scrolling()
})

function scrolling() {
  const currentScroll = window.pageYOffset

  if (currentScroll) {
    body.classList.add(scrolled)
    body.classList.remove(ontop)
  } else {
    body.classList.remove(scrolled)
    body.classList.add(ontop)
  }

  if (currentScroll <= 75) {
    body.classList.remove(scrollUp)
    return
  }

  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    // down
    body.classList.remove(scrollUp)
    body.classList.add(scrollDown)
  } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
    // up
    body.classList.remove(scrollDown)
    body.classList.add(scrollUp)
  }
  lastScroll = currentScroll
}

$(document.body).on('added_to_cart updated_cart_totals', function () {
  $.ajax({
    url: '/wp/wp-admin/admin-ajax.php',
    type: 'POST',
    dataType: 'json',

    data: {
      action: 'retrieve_cart_products_amount',
    },

    success: function (response) {
      $('.cart-quantity').css('opacity', 1).text(response.amount)
    },
  })
})



// WEBPACK FOOTER //
// ./scripts/main.js